import { LOAD_TYPES } from 'screens/YieldV2/Loads/constants';

const validateSource = (_tabs, sourceType) => {
  if (sourceType === LOAD_TYPES.CROP_ZONE) {
    return _tabs;
  }
  if (sourceType === LOAD_TYPES.STORAGE) {
    return _tabs;
  }
  if (sourceType === LOAD_TYPES.SALE) {
    return _tabs;
  }
  return _tabs;
};

export default validateSource;
